import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Translate from 'react-translate-component';
import { Popover, Tooltip } from 'antd';

const tooltipDelaySeconds = 1;

export default class TableContentCell extends Component {
    static propTypes = {
        content: PropTypes.node,
        translation: PropTypes.string
    }

    state = {
        visible: false,
    }

    hide = (visible) => {
        this.setState({ visible });
    }

    render() {
        const { visible } = this.state;
        const { content, translation } = this.props;

        const popover = <div onClick={() => this.hide(false)}>{content}</div>;

        return (
            <Tooltip placement="right"
                     overlayClassName="table-tooltip"
                     mouseEnterDelay={tooltipDelaySeconds}
                     getPopupContainer={() => document.querySelector('.sticky-table-y-wrapper')}
                     title={<Translate content="common.showPopover" />}>
                <Popover overlayClassName="table-popover"
                         onVisibleChange={this.hide}
                         visible={visible}
                         content={popover}
                         trigger="click"
                         title={<Translate content={translation}/>}>
                    <div className={cx('table-cell-content-popover', { visible } )}></div>
                </Popover>
            </Tooltip>
        );
    }
}
